import { Fragment, cloneElement, lazy } from 'react';
import { MFLazyLoad } from '@medifind/shared-basic-components';
const CovidProfileBadge = lazy(() => import('./CovidProfileBadge'));
const MyositisProfileBadge = lazy(() => import('./MyositisProfileBadge'));

const ProfileConditionBadgeContainer = ({ badgeList = [] }) => {
  const badges = {
    Myositis: <MyositisProfileBadge />,
    'Long Haul Covid': <CovidProfileBadge />,
  };
  return (
    <>
      {badgeList.map((condition) => {
        return (
          badges[condition] && (
            <MFLazyLoad height={56}>
              {' '}
              <Fragment key={condition}>{cloneElement(badges[condition])}</Fragment>{' '}
            </MFLazyLoad>
          )
        );
      })}
    </>
  );
};

export { ProfileConditionBadgeContainer as default, ProfileConditionBadgeContainer };
